import React from "react";

const ContentCardSkeleton: React.FC<{ variant?: "card" | "initiative" }> = ({
  variant = "card",
}) => {
  const isInitiative = variant === "initiative";

  return (
    <div
      className={isInitiative ? "col-lg-6 mb-4" : "col-xl-4 col-lg-4 col-md-6 mb-4"}
      aria-hidden="true"
    >
      <div className={isInitiative ? "initiative-card-skeleton" : "blog-card-skeleton"}>
        <div className="skeleton skeleton-image" />
        <div className="skeleton-content">
          <div className="skeleton skeleton-title" />
          <div className="skeleton skeleton-line" />
          <div className="skeleton skeleton-line short" />
          {!isInitiative && (
            <div className="skeleton-tags">
              <span className="skeleton skeleton-tag" />
              <span className="skeleton skeleton-tag" />
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default ContentCardSkeleton;
